import React, { useContext } from 'react'
import { SessionContext } from 'data/context'
import { TBody, Row } from './Styled'
import { IData, IForm } from '../'

export const TR: React.FC<{ data: IData; lastRow: boolean; form: IForm }> = ({
  data,
  lastRow,
  form: { setFormData, setShowForm }
}) => {
  const { location, year, make, model, stknum, vinnum, description } = data
  const { readOnly } = useContext(SessionContext)
  return (
    <TBody>
      <Row lastRow={lastRow}>
        {!readOnly && (
          <td
            onClick={() => {
              setFormData(data)
              setShowForm(true)
            }}
          >
            Edit
          </td>
        )}
        <td>{location}</td>
        <td>{year}</td>
        <td>{make}</td>
        <td>{model}</td>
        <td>{stknum}</td>
        <td>{vinnum}</td>
        <td>{description}</td>
      </Row>
    </TBody>
  )
}
